import { useCallback, useMemo } from "react";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { GenericSelect } from "../../../../shared/components/AppGenericSelect";
import {
  selectInstanceAgents,
  selectSelectedInstanceAgent,
} from "../../redux/selectors";
import { TDeerFlowInstanceAgent } from "../../../../services/api/instances/deerflowApi/types";
import { setSelectedDeerFlowInstancesAgent } from "../../redux/slice";
import styles from "./styles.module.css";
import { createDeerFlowInstanceThread } from "../../redux/actions";

interface Props {
  isDisabled: boolean;
  className?: string;
}

export const DeerFlowAgentsSelect = ({ isDisabled, className }: Props) => {
  const dispatch = useAppDispatch();
  const instanceAgents = useAppSelector(selectInstanceAgents);
  const selectedInstanceAgent = useAppSelector(selectSelectedInstanceAgent);

  const agents = useMemo(() => {
    return instanceAgents;
  }, [instanceAgents]);

  const handleSelectInstanceAgent = useCallback(
    (agent: TDeerFlowInstanceAgent | null) => {
      dispatch(setSelectedDeerFlowInstancesAgent(agent));
      if (agent) {
        dispatch(createDeerFlowInstanceThread(agent.name));
      }
    },
    [instanceAgents],
  );

  return (
    <GenericSelect<TDeerFlowInstanceAgent>
      options={agents}
      value={selectedInstanceAgent}
      onChange={handleSelectInstanceAgent}
      getLabel={(agent) => agent.name}
      getValue={(agent) => agent.name}
      placeholder={"Выберите агента"}
      className={styles["agent-select"]}
      isDisabled={isDisabled && agents.length === 0}
    />
  );
};
